import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate, NumberInput, BooleanInput /* , SelectInput */ } from 'admin-on-rest';
import { Field, change as onChange, getFormValues } from 'redux-form';
import equal from 'deep-equal';

import { compose } from 'recompose';

import PriceInput from './PriceInput';
// import { getTranslationByLocale } from '../../utils/TranslationUtils';

const styles = {
  wrapper: { padding: '1em 0' },
  marketContent: { padding: '0.3em 1em 1em 1em' },
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  icon: { margin: '-2px 0 0 3px', width: '16px', height: '16px' },
  marketText: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
};

// eslint-disable-next-line no-shadow
export class ProductPriceInput extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount = () => {
    this.hydrateMarkets(this.props);
  };

  // Only update if we get new choices (usually initial page load)
  // or when the record markets have changed (been hydrated)
  // shouldComponentUpdate = (nextProps, nextState) => !equal(this.props, nextProps) || !equal(this.state, nextState);

  shouldComponentUpdate = ({ choices, record }) => {
    const oldMarketsLength = this.props.choices.markets;
    const nextMarketsLength = choices.markets.length;

    // console.log('hydratin');
    // console.log('oldMarketsLength.length < nextMarketsLength && nextMarketsLength', oldMarketsLength.length < nextMarketsLength && nextMarketsLength);
    // console.log('nextMarketsLength && !!this.props.record.markets && !!record.markets && this.props.record.markets.length !== record.markets.length', nextMarketsLength && !!this.props.record.markets && !!record.markets && this.props.record.markets.length !== record.markets.length);
    // console.log('nextMarketsLength && record.markets && JSON.stringify(choices.markets.reduce((sum, value) => sum.concat(value.countryCode), [])) !== JSON.stringify(record.markets.reduce((sum, value) => sum.concat(value.countryCode), []))', nextMarketsLength && record.markets && JSON.stringify(choices.markets.reduce((sum, value) => sum.concat(value.countryCode), [])) !== JSON.stringify(record.markets.reduce((sum, value) => sum.concat(value.countryCode), [])));
    // console.log('!equal(this.props.record.markets && this.props.record.markets.reduce((sum, value) => sum.concat({ ignorePriceSegment: value.ignorePriceSegment }), []), record.markets.reduce((sum, value) => sum.concat({ ignorePriceSegment: value.ignorePriceSegment }), []))', !equal(this.props.record.markets && this.props.record.markets.reduce((sum, value) => sum.concat({ ignorePriceSegment: value.ignorePriceSegment }), []), record.markets.reduce((sum, value) => sum.concat({ ignorePriceSegment: value.ignorePriceSegment }), [])));

    return (
      (oldMarketsLength.length < nextMarketsLength && nextMarketsLength) ||
      ((nextMarketsLength &&
        !!this.props.record.markets &&
        !!record.markets &&
        this.props.record.markets.length !== record.markets.length) ||
        !equal(this.props.record.market, record.market) ||
        // (nextMarketsLength && record.markets && JSON.stringify(choices.markets.reduce((sum, value) => sum.concat(value.countryCode), [])) !== JSON.stringify(record.markets.reduce((sum, value) => sum.concat(value.countryCode), [])))
        // ||
        !equal(
          this.props.record.markets &&
            this.props.record.markets.reduce(
              (sum, value) => sum.concat({ ignorePriceSegment: value.ignorePriceSegment }),
              []
            ),
          record.markets.reduce(
            (sum, value) => sum.concat({ ignorePriceSegment: value.ignorePriceSegment }),
            []
          )
        ))
    );
  };

  componentWillUpdate = (nextProps) => {
    this.hydrateMarkets(nextProps);
  };

  // To show the markets values in the proper markets we need to hydrate the empty markets in the record state.
  // To do this we must call hydrateMarkets in both componentDidMount to do it on initial load when going into
  // a product via the product list and in componentWillUpdate to do it when you reload the page or come in
  // to a product via an already rendered list... it might be slightly confusing.
  hydrateMarkets = ({ choices, record, change, source }) => {
    if (
      (record &&
        record.markets &&
        choices.markets.length > 0 &&
        choices.markets.length > record.markets.length) ||
      !record.markets
    ) {
      console.log('hydratin');

      const newRecord = { ...record };
      newRecord[source] = choices.markets.map((market) => {
        const existingMarket =
          record.markets &&
          record.markets.find((mrkt) => mrkt && mrkt.countryCode === market.countryCode);
        if (existingMarket) {
          return { ...existingMarket, countryCode: market.countryCode, marketId: market.id };
        }
        return { countryCode: market.countryCode, marketId: market.id, ignorePriceSegment: false };
      });
      change('record-form', 'markets', newRecord[source]);
    }
  };

  render() {
    // eslint-disable-next-line no-shadow
    const { source, choices, record /* , locale */ } = this.props;
    const { market, markets } = record;

    if (!market || !choices.markets.length) {
      return null;
    }
    const selectedMarket = choices.markets.find((m) => m.id === market);
    const index = markets.findIndex((m) => m.marketId === selectedMarket.id);
    const hasMultiplePrices = markets.filter((m) => m.suggestedPrice > 0).length > 1;

    if (hasMultiplePrices || index === -1) {
      return <h3>Price corrupt, report to developers</h3>;
    }

    return (
      <div style={styles.wrapper}>
        <Field
          key={`${market.countryCode}.vat`}
          name={`${source}[${index}].vat`}
          type="number"
          component={(props) => <NumberInput {...props} />}
          label="markets.vat"
        />
        <Field
          key={`${market.countryCode}.suggestedPrice`}
          name={`${source}[${index}].suggestedPrice`}
          component={(props) => (
            <PriceInput
              precision={selectedMarket.currencyPrecision}
              currencyCode={selectedMarket.currencyCode}
              {...props}
              {...this.props}
            />
          )}
          label="suggestedPrice"
        />
        <Field
          key={`${market.countryCode}.minPrice`}
          name={`${source}[${index}].minPrice`}
          // component={(props) => <PriceInput disabled={!marketData.ignorePriceSegment} precision={selectedMarket.currencyPrecision} currencyCode={selectedMarket.currencyCode} {...props} {...this.props} />}
          component={(props) => (
            <PriceInput
              precision={selectedMarket.currencyPrecision}
              currencyCode={selectedMarket.currencyCode}
              {...props}
              {...this.props}
            />
          )}
          label="minPrice"
        />
        <Field
          key={`${market.countryCode}.maxPrice`}
          name={`${source}[${index}].maxPrice`}
          // component={(props) => <PriceInput disabled={!marketData.ignorePriceSegment} precision={selectedMarket.currencyPrecision} currencyCode={selectedMarket.currencyCode} {...props} {...this.props} />}
          component={(props) => (
            <PriceInput
              precision={selectedMarket.currencyPrecision}
              currencyCode={selectedMarket.currencyCode}
              {...props}
              {...this.props}
            />
          )}
          label="maxPrice"
        />
        <Field
          key={`${market.countryCode}.ignorePriceSegment`}
          name={`${source}[${index}].ignorePriceSegment`}
          component={(props) => <BooleanInput {...props} {...this.props} />}
          label="markets.ignorePriceSegment"
        />
        <Field
          key={`${market.countryCode}.consumesLoyalty`}
          name={`${source}[${index}].consumesLoyalty`}
          component={(props) => <BooleanInput {...props} />}
          label="markets.consumesLoyalty"
        />
        {/* <Field
                      key={`${market.countryCode}.producesLoyalty`}
                      name={`${source}[${index}].producesLoyalty`}
                      component={(props) => <BooleanInput {...props} />}
                      label="markets.producesLoyalty"
                    /> */}
        {/* <Field
          key={`${market.countryCode}.overrideMainImageUrl`}
          name={`${source}[${index}].overrideMainImageUrl`}
          component={(props) => (
            <ImageInput
              {...props}
              label="markets.overrideMainImageUrl"
              source={`${source}[${index}].overrideMainImageUrl`}
              accept="image/*"
            >
              <ThumbnailImageField source="src" />
            </ImageInput>
          )}
          label="markets.overrideMainImageUrl"
        /> */}
        {/* <Field
                      key={`${market.countryCode}.countryCode`}
                      name={`${source}[${index}].countryCode`}
                      component={(props) => <input style={{ display: 'none' }} {...props} />}
                      type="text"
                      label={`${market.name} ${translate(`resources.${resource}.fields.${source}`)}`}
                    /> */}
      </div>
    );
  }
}

ProductPriceInput.propTypes = {
  source: PropTypes.string,
  choices: PropTypes.object,
};

ProductPriceInput.defaultProps = {
  choices: { markets: [] },
};

const selector = getFormValues('record-form');

const enhance = compose(translate);

export default connect(
  (state) => ({ record: selector(state) }),
  { change: onChange }
)(enhance(ProductPriceInput));
